import React from "react";
import { MdClose } from "react-icons/md";

import Loader from "react-loader-spinner";
import "react-phone-input-2/lib/style.css";

import { toastMessage } from "../../../utils/toast";
import { dateTimeFormat } from "../../../utils";
import * as jobActions from "../../../Redux/Actions/jobs";
import { clearSession } from "../../../utils/initiate";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function PaymentSummaryModal({
  showModal,
  handleCancel,
  id,
  loading,
  setLoading,
  history,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [summaryDetails, setSummaryDetais] = useState([]);

  useEffect(() => {
    jobActions
      .getAdditionalPaymentLogs(id)
      .then((res) => {
        if (res?.data) {
          setSummaryDetais(res.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          clearSession(dispatch, history);
          toastMessage("error", `Access Denied`);
        } else {
          toastMessage(
            "error",
            `Unable to get additional payment summary logs `
          );
        }
        setLoading(false);
      });
  }, [id]);
  return (
    <div>
      {
        <div>
          <div
            className="modal"
            style={{
              display: showModal ? "block" : "",
              alignItems: "center",
            }}
          >
            <div className="modal-dialog" style={{ maxWidth: "600px" }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 style={{ color: "white" }}></h5>
                  <button
                    type="button"
                    className="close p-1 rounded"
                    aria-label="Close"
                    onClick={handleCancel}
                    style={{ border: "none" }}
                  >
                    <MdClose />
                  </button>
                </div>
                <div className="modal-body">
                  {loading ? (
                    <div className="d-flex align-items-center justify-content-center h-75vh">
                      <Loader
                        type="ThreeDots"
                        color="#2d207d"
                        height={40}
                        width={40}
                        style={{ textAlign: "center" }}
                      />
                    </div>
                  ) : (
                    <div className="card">
                      <div className="card-header border-0">
                        <h4 className="card-title">
                          {t("jobsManagement.infoJob.statusInfo")}
                        </h4>
                      </div>
                      <div className="card-body">
                        <div className="slimscroll">
                          <div className="activity">
                            {summaryDetails && summaryDetails.length === 0 ? (
                              <p className="text-muted text-center">
                                {t("jobsManagement.noDataAvailable")}
                              </p>
                            ) : (
                              summaryDetails &&
                              summaryDetails.map(
                                ({ message, createdTime }, index) => {
                                  return (
                                    <div className="activity-info" key={index}>
                                      <div className="icon-info-activity">
                                        <i className="fst-normal las la-check-circle bg-soft-primary">
                                          {index + 1}
                                        </i>
                                      </div>
                                      <div className="activity-info-text">
                                        <div className="d-flex flex-column align-items-start">
                                          <div className="d-flex">
                                            <p className="d-flex align-items-center badge badge-soft-primary">
                                              {message}
                                            </p>
                                          </div>
                                          <p className="text-muted font-11 mt-1">
                                            {dateTimeFormat(createdTime)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}            
                </div>

                <div className="modal-footer"></div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </div>
      }
    </div>
  );
}
